import { ReactElement } from 'react'
import styled from 'styled-components'

import { IIconProps } from 'components/Icons/types'

const Svg = styled.svg`
  width: 12px;
  height: 13px;
`

interface IPolygonIconProps extends IIconProps {
  fillColor?: string
  strokeColor?: string
}

export const PolygonIcon = ({
  className,
  fillColor = '#E3E3E3',
  strokeColor = '#717171'
}: IPolygonIconProps): ReactElement => {
  return (
    <Svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 13" className={className}>
      <path
        d="M2.83301 6L5.33301 3.5H7.83301L9.33301 9.5L8.83301 10L8.33301 11L3.33301 8.5L2.83301 6Z"
        fill={fillColor}
      />
      <path
        d="M7.32031 0C7.60149 1.32482e-05 7.84013 0.098939 8.03711 0.295898C8.23408 0.492866 8.33298 0.731533 8.33301 1.0127V2.6543C8.33294 2.82878 8.29468 2.98686 8.21875 3.12891L9.73145 9.33301H10.6533C10.9345 9.33301 11.1741 9.43191 11.3711 9.62891C11.5679 9.82577 11.6659 10.0647 11.666 10.3457V11.9873C11.666 12.2683 11.5679 12.5072 11.3711 12.7041C11.1741 12.9011 10.9345 13 10.6533 13H9.0127C8.73147 13 8.49192 12.9011 8.29492 12.7041C8.0982 12.5072 8.00003 12.2683 8 11.9873V11.3975L3.20508 9H1.0127C0.731473 9 0.491922 8.9011 0.294922 8.7041C0.0981983 8.5072 3.21602e-05 8.26829 0 7.9873V6.3457C0.000108072 6.06478 0.0981657 5.82576 0.294922 5.62891C0.491922 5.43191 0.731473 5.33301 1.0127 5.33301H2.77637L4.66602 3.16406V1.0127C4.66605 0.73163 4.76508 0.492827 4.96191 0.295898C5.15891 0.0988984 5.39847 0 5.67969 0H7.32031ZM9 12H10.666V10.333H9V12ZM7.32031 3.66699H5.55566L3.66602 5.83594V8.10254L8.05078 10.29V10.0586C8.10548 9.84596 8.22111 9.67162 8.39746 9.53613C8.49369 9.46231 8.59882 9.40956 8.71191 9.37598L7.32129 3.66602L7.32031 3.66699ZM1 8H2.66602V6.33301H1V8ZM5.66602 2.66699H7.33301V1H5.66602V2.66699Z"
        fill={strokeColor}
      />
    </Svg>
  )
}
